import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const DependentsQuantityBlobStyled = styled.div`
  border-radius: 50rem;
  background-color: ${colors.neutral[200]};
  display: inline-block;
  margin-left: 0.8rem;
  box-sizing: border-box;
  width: 3rem;
  height: 2rem;
  text-align: center;
  vertical-align: middle;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 2rem;
`;
